import { render, staticRenderFns } from "./SinglePurchase.vue?vue&type=template&id=307b7e41&"
import script from "./SinglePurchase.vue?vue&type=script&lang=js&"
export * from "./SinglePurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SinglePurchase.vue"
export default component.exports